import { useEffect } from "react";

export function SEO({ title, description }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("name", "description");
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", description);
      let og = document.querySelector('meta[property="og:description"]');
      if (og) og.setAttribute("content", description);
      let ogTitle = document.querySelector('meta[property="og:title"]');
      if (ogTitle && title) ogTitle.setAttribute("content", title);
    }
  }, [title, description]);
  return null;
}
